import SubscriptionAmountType from '@/shared/enums/SubscriptionAmountType'
import SubscriptionPeriodicity from '@/shared/enums/SubscriptionPeriodicity'
import SubscriptionRetryPolicy from '@/shared/enums/SubscriptionRetryPolicy'
import SubscriptionScheme from '@/shared/enums/SubscriptionScheme'
import CheckoutConfig from '@/shared/models/CheckoutConfig'

export default class Subscription {
  readonly scheme: SubscriptionScheme
  readonly retryPolicy: SubscriptionRetryPolicy
  readonly amountType: SubscriptionAmountType
  readonly initialCharge: boolean
  readonly asset: string
  readonly amount: string
  readonly minimumAmount: string
  readonly periodicity: SubscriptionPeriodicity
  readonly merchantInitiation: boolean
  readonly dueDate: string
  readonly endDate?: string
  readonly forceWorkDay: boolean
  readonly notificationUrl?: string
  readonly description?: string
  readonly customPeriodType?: string
  readonly customPeriodCount?: number
  readonly referenceId?: string
  readonly expirationDate?: string

  constructor(config: CheckoutConfig) {
    this.scheme = config.subscriptionScheme
    this.retryPolicy = config.subscriptionRetryPolicy
    this.amountType = config.subscriptionAmountType
    this.initialCharge = config.subscriptionInitialCharge ?? false
    this.asset = config.subscriptionAsset
    this.amount = config.subscriptionAmount
    this.minimumAmount = config.subscriptionMinimumAmount
    this.periodicity = config.subscriptionPeriodicity
    this.merchantInitiation = config.subscriptionMerchantInitiation ?? false
    this.dueDate = config.subscriptionDueDate
    this.endDate = config.subscriptionEndDate
    this.forceWorkDay = config.subscriptionForceWorkDay ?? false
    this.notificationUrl = config.subscriptionNotificationUrl
    this.description = config.subscriptionDescription
    this.customPeriodType = config.subscriptionCustomPeriodType
    this.customPeriodCount = config.subscriptionCustomPeriodCount
    this.referenceId = config.subscriptionReferenceId
    this.expirationDate = config.expirationDate
  }
}
